export class CustomFieldsDtColumnName {
    public static readonly Name = 'label';
    public static readonly Category = 'category';
    public static readonly Type = 'type';

}
